// Validated environment access. Required vars throw at import time so a
// misconfigured deployment fails on boot rather than silently falling back
// to a stale default. Optional vars use ?? for sensible defaults.

function optional(name: string, fallback: string): string {
  const v = import.meta.env[name];
  return v && v.length > 0 ? v : fallback;
}

const DEFAULT_IDENTITY_AUTHORITY = 'https://id.dev.know.sh';
const DEFAULT_IDENTITY_CLIENT_ID = 'know-web';
const DEFAULT_API_AUDIENCE = 'https://mcp.dev.know.sh';

export const env = {
  // Empty = same-origin; the nginx reverse-proxy (prod) or Vite dev-server
  // proxy forwards /v1/* to the right backend. Override only for exotic
  // deployments where the API is on a truly different origin.
  apiBaseUrl: optional('VITE_API_BASE_URL', optional('VITE_USERS_API_BASE_URL', '')),

  // The agent loop is a separate service from know-api.
  // Defaults to apiBaseUrl so same-origin nginx routing (which forwards
  // /v1/agent/* to know-agent at the proxy layer) keeps working without
  // a second env var. Override when the SPA needs to hit know-agent on
  // a distinct origin.
  agentBaseUrl: optional(
    'VITE_AGENT_BASE_URL',
    optional('VITE_API_BASE_URL', optional('VITE_USERS_API_BASE_URL', '')),
  ),

  webPushPublicKey: optional('VITE_WEB_PUSH_PUBLIC_KEY', ''),

  identity: {
    authority: optional('VITE_IDENTITY_AUTHORITY', DEFAULT_IDENTITY_AUTHORITY),
    clientId: optional('VITE_IDENTITY_CLIENT_ID', DEFAULT_IDENTITY_CLIENT_ID),
    accountResource: optional(
      'VITE_IDENTITY_ACCOUNT_RESOURCE',
      `${optional('VITE_IDENTITY_AUTHORITY', DEFAULT_IDENTITY_AUTHORITY).replace(/\/$/, '')}/account`,
    ),
  },

  // The identity tenant's primary API resource, which every backend accepts.
  // Each environment names its own (dev: mcp.dev.know.sh, prod: mcp.know.sh).
  apiAudience: optional('VITE_API_AUDIENCE', DEFAULT_API_AUDIENCE),
} as const;
